import type { SplitExperimentProps, SplitProps } from './types';
import { getSplitState } from './utils';
import { DispatchConstants } from './constants';

export const initState = ({ experiments = {}, featureNames = [] }: Partial<SplitProps> = {}) => {
  return getSplitState({ experiments, featureNames });
};

export const reducers = (
  state: SplitProps,
  action: { type?: string; payload?: SplitExperimentProps | Array<string> | string } = {},
): SplitProps => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.UPDATE_SPLIT_EXPERIMENTS: {
      if (!payload) return { ...state };

      return {
        ...state,
        experiments: {
          ...(state.experiments as Record<string, SplitExperimentProps>),
          [(payload as SplitExperimentProps).featureName]: payload as SplitExperimentProps,
        },
      };
    }

    case DispatchConstants.DELETE_SPLIT_EXPERIMENT: {
      if (!payload) return { ...state };

      delete state.experiments[payload as string];

      return {
        ...state,
        experiments: {
          ...(state.experiments as Record<string, SplitExperimentProps>),
        },
      };
    }

    case DispatchConstants.UPDATE_SPLIT_FEATURE_NAMES:
      return { ...state, featureNames: payload as Array<string> };

    default:
      return state;
  }
};
